import queryString from "query-string";

import { defaultApi } from "../../../../utils/axiosApi";

import { createNotification } from "../../../../modules/notificationManager";

const httpExtract = async () => {
  const url = window.location;
  const result = {};
  const parsed = queryString.parse(url.search);

  if (parsed && parsed.code) {
    result.code = parsed.code;
    result.state = parsed.state;
  }

  return result;
};

const installIntegrationRequest = async (parsedParams, data) => {
  const { organization_id, integration_id } = data;
  const url = `${organization_id}/integrations/${integration_id}/install/`;
  const payload = { data: parsedParams };

  try {
    const response = await defaultApi(url, "POST", payload);
    if (response && response.status === 200) {
      return true;
    }
    return false;
  } catch (err) {
    createNotification(
      "error",
      "Sorry! Could not install asana integration. Please try again.",
      3000
    );
    return false;
  }
};

export const executeAsanaSteps = async (data) => {
  const parsedParams = await httpExtract();
  const isInstalled = await installIntegrationRequest(parsedParams, data);

  return { isInstalled };
};
